import React, { useRef, useEffect } from 'react';
import classes from './Register.module.scss';
//@ts-ignore
import iframeResize from 'iframe-resizer/js/iframeResizer';
import Meta from '../../components/Meta/Meta';

interface RegisterProps extends React.HTMLProps<HTMLDivElement> {
  srcUrl: string;
  noindex?: boolean;
  nofollow?: boolean;
}

export default function Register({ srcUrl, noindex, nofollow }: RegisterProps) {
  const ref = useRef<HTMLDivElement | null>(null);

  async function insertLocator() {
    let { default: postscribe } = await import('postscribe');

    postscribe(
      ref.current,
      `<script defer type="text/javascript" language="javascript" src="${srcUrl}" ></script>;`,
    );
  }

  async function handleSubtreeModify() {
    const iframe: Element | null | undefined = document?.querySelector('#locator_iframe15507');
    setTimeout(() => {
      if (iframe) {
        iframeResize({}, iframe);
      }
    }, 0);
  }

  useEffect(() => {
    if (window && ref.current) {
      insertLocator();
      (ref.current as HTMLDivElement)?.addEventListener('DOMSubtreeModified', handleSubtreeModify);
    }

    return () => {
      (ref.current as HTMLDivElement)?.removeEventListener('DOMSubtreeModified', handleSubtreeModify);
    };
  }, [ref.current]);

  return (
    <main className={classes.register}>
      <Meta noindex={noindex} nofollow={nofollow} />
      <div ref={ref} />
    </main>
  );
};
